import { Component } from 'react';
import { ArrowRight, Bug } from 'lucide-react';
import { recordDevAttention } from './ai.js';
import { BUILD_VERSION, BrandMark } from './branding.jsx';

export default class RouteErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    void recordDevAttention({
      route: this.props.route || 'unknown',
      message: error?.message || 'Unknown client rendering failure',
      stack: error?.stack || '',
      componentStack: info?.componentStack || '',
      userAgent: typeof navigator === 'undefined' ? '' : navigator.userAgent,
      viewport: typeof window === 'undefined' ? '' : `${window.innerWidth}x${window.innerHeight}`,
      build: BUILD_VERSION,
    });
    this.props.onCrash?.();
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="view route-recovery-view"><BrandMark /><Bug /><h1>Looks needs a reset.</h1><p>We caught the problem and sent a private development note. Returning you to Today should get your closet moving again.</p><button onClick={this.props.onRecover}>Return to Today <ArrowRight /></button></main>;
  }
}
